import React, { useMemo, useCallback, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { CircularProgress } from '@material-ui/core';
import { Visibility } from '@material-ui/icons';
import axios from 'axios';
import { parseISO, format } from 'date-fns';
import { isArray, replace } from 'lodash';

import IconExcel from '~/assets/icons/icons8-ms-excel.svg';
import { Tabela, Modal } from '~/components';
import { t } from '~/helpers';
import {
  dataInRequest,
  recordFiltering,
} from '~/store/modules/consultaAvancada/actions';

export default function ConsultaAvancada() {
  const redux = useSelector((state) => state.consultaavancada);

  const { token } = useSelector((state) => state.auth);

  const modalRef = useRef(null);

  const [loading, setLoading] = useState(false);

  const header = useMemo(
    () => [
      {
        id: 'nomeconsultaavancada',
        label: t('s.configuracao.posto.nomeposto'),
        filter: { type: 'text' },
      },
      {
        id: 'codigousuario',
        label: t('s.operacao.recebimento.idusuario'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeusuario',
        label: t('s.geral.camposistema.nomeusuario'),
        filter: { type: 'text' },
      },
      // {
      //     id: 'publicoconsultaavancada',
      //     label: t('s.relatorio.consultaavancada.publicoconsultaavancada'),
      //     filter: { type: 'text' },
      // },
    ],
    []
  );

  const openWithHeaders = (url, headers) => {
    const params = new URLSearchParams(url.split('?')[1]);

    // Cria um formulário dinâmico
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = url.split('?')[0];
    form.target = '_blank'; // Abre em uma nova janela/aba

    params.forEach((value, key) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });

    // Adiciona os headers como campos ocultos
    for (const [key, value] of Object.entries(headers)) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    }

    // Adiciona o formulário ao DOM, envia e remove
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };

  const handleGetExcel = useCallback(
    async (values) => {
      try {
        const REACT_APP_URL_DOWNLOAD = replace(
          sessionStorage.getItem('URL_REPORT'),
          '/relatorios',
          '/ConsultaAvancada'
        );

        setLoading(true);
        const url = new URL(REACT_APP_URL_DOWNLOAD);
        url.search = new URLSearchParams({
          // token,
          idconsultaavancada: values.idconsultaavancada,
        });

        const response = await axios({
          url,
          method: 'GET',
          responseType: 'application/vnd.ms-excel',
          headers: {
            Authorization: `Bearer ${token}`, // Cabeçalho de autenticação
          },
        });

        if (response.config.method.toLowerCase() === 'get') {
          const url = response.config.url.href ?? response.config.url;
          const headers = {
            Authorization: `Bearer ${token}`,
          };
          openWithHeaders(url, headers);
        }

        window.open(response.config.url.href);

        // const { data } = response

        // const file = new Blob([data], { type: 'application/vnd.ms-excel' });

        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //     window.navigator.msSaveOrOpenBlob(file);
        // } else {

        //     const objectUrl = URL.createObjectURL(file);
        //     console.log(objectUrl)

        //     window.open(objectUrl)
        // }
      } catch (err) {
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));
      } finally {
        setLoading(false);
      }
    },
    [token]
  );

  const actions = useMemo(
    () => [
      {
        title: t('s.relatorio.consultaavancada.baixarexcel'),
        action: (value) => handleGetExcel(value),
        icon: loading ? (
          <CircularProgress
            size={20}
            color="primary"
            style={{ marginRight: '1.5rem' }}
          />
        ) : (
          <img src={IconExcel} />
        ),
      },
    ],
    [loading]
  );

  return (
    <>
      <Tabela
        read={dataInRequest}
        state={redux}
        header={header}
        buttons={actions}
        recordFilter={recordFiltering}
        headerMobile="nomeconsultaavancada"
        unique={['idconsultaavancada']}
        noEdition
      />

      {/* <Modal
                disableBackdropClick
                disableEscapeKeyDown
                ref={modalRef}
                loading={loading}
                component={ItemDetail}
                actions={buttons}
                title={t('s.menu.relatorio.auditoria')}
            /> */}
    </>
  );
}
